import { getBackboneWindow } from '../getBackboneWindow'

export const openJumpSearch = (): void => {
  const backboneWindow = getBackboneWindow()
  if (backboneWindow !== null) {
    backboneWindow.parent.postMessage({ message: 'asgard:jump:open' }, '*')
  }
}
